

































































































































































import BaseComponent from '@/core/base.component';
import { AdminDto, SpaceTypeDto } from '@/dto';
import { BaseUser } from '@/services/shared/auth';
import { Component, Vue } from 'vue-property-decorator';
import AdminService from '@/services/admin.service';
import SpaceTypeService from '@/services/space-type.service';
import { SPACE_TYPE } from '@/services/shared';
import toast from '../../../../resources/assets/js/services/toast.js';
@Component({
  name: 'AdminDetail',
})
export default class AdminDetail extends BaseComponent {
  private adminDto = new AdminDto(BaseUser);
  private spaceTypes: SpaceTypeDto[] = [];
  private adminUpdateDto: AdminDto = new AdminDto(BaseUser);
  private myPageDto: AdminDto = new AdminDto(BaseUser);

  findMe() {
    AdminService.findMe().subscribe(res => {
      if (res) {
        this.myPageDto = res.data;
      }
    });
  }

  findOne() {
    AdminService.findOne(this.$route.params.id).subscribe(res => {
      this.adminDto = res.data;
    });
  }

  findSpaceType() {
    SpaceTypeService.findForSelect().subscribe(res => {
      this.spaceTypes = res.data;
    });
  }

  showUpdateModal() {
    AdminService.findOne(this.$route.params.id).subscribe(res => {
      this.adminUpdateDto = res.data;
    });
  }

  updateAdmin() {
    AdminService.update(this.$route.params.id, this.adminDto).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.findOne();
      }
    });
  }

  deleteOne() {
    AdminService.hardDelete(this.$route.params.id).subscribe(res => {
      if (res) {
        toast.success('삭제완료');
        this.$router.push('/admin');
      }
    });
  }

  created() {
    this.findSpaceType();
    this.findOne();
    this.findMe();
  }
}
